import React from "react";
import { useEffect, useState } from "react";
import { Fragment } from "react";
import LearnMore from "./LearnMore";
import QuickStartKit from "./QuickStartKit";
import About from "./About";
import Support from "./Support";
import RinkForm from "./RinkForm";
import UpgradeCalc from "./UpgradeCalc";
import Packages from "./Packages";
import { ToastContainer } from "react-toastify";

function Home(props) {
  const [path, setPath] = useState("");

  useEffect(() => {
    const currentPath = window.location.pathname;
    setPath(currentPath);
  }, []);

  return (
    <Fragment>
      <div className="max-w-[2560px] m-auto">
        {path.endsWith("/ice-rink") && <LearnMore product="ICE_RINK" />}
        {path.endsWith("/synthetic-rink") && (
          <LearnMore product="SYNTHETIC_RINK" />
        )}
        {path.endsWith("/synthetic-rink-form") && (
          <RinkForm product="SYNTHETIC_ICE_RINK" />
        )}
        {path.endsWith("/street-hockey-rink") && (
          <LearnMore product="STREET_HOCKEY_RINK" />
        )}
        {path.endsWith("/street-hockey-rink-form") && (
          <RinkForm product="STREET_HOCKEY_RINK" />
        )}
        {path.endsWith("/ez-ice-quick-start-kit") && <QuickStartKit />}
        {path.endsWith("/about") && <About />}
        {path.endsWith("/support") && <Support />}
        {path.endsWith("/upgrade") && <UpgradeCalc />}
        {path.endsWith("/packages") && <Packages />}

        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Fragment>
  );
}

export default Home;
